
export enum ReportTimeTypeEnum {
  POINTS = "POINTS",
  TRAVEL_MINUTES = "TRAVEL_MINUTES",
  WORK_MINUTES = "WORK_MINUTES",
  TOTAL = "TOTAL",
}
